<template>
  <div class="md-layout" role="banner">
    <div class="md-layout-item md-size-25 logo-div  md-xsmall-size-45">
      <img
        class="customimg logo"
        src="../assets/logo.png"
        aria-hidden="true"
        role="presentation"
        alt="Logo uVote"
      />
      <span></span>
    </div>
    <!-- <div class="md-layout-item md-size-20  md-xsmall-size-5"></div> -->
    <div class="md-layout-item md-size-50  md-xsmall-size-5 center-header">
      <img
        class="customimg logo-evt  md-xsmall-hide"
        v-bind:src="
          'data:image/jpeg;base64,' +
            $store.state.electionEvent.ElectionEvent.EventLogo.Binary.value
        "
        aria-hidden="true"
        role="presentation"
        :alt="$t('header.logo')"
        v-if="$store.state.electionEvent"
      />
      <div class="text  md-xsmall-hide">
        <div>
          <b v-if="$store.state.electionEvent" class="event-name">
            <span class="screenreader"
              >{{ $t("election-event.screen-reader.title") }}:
            </span>
            {{
              $store.state.electionEvent.ElectionEvent.EventIdentifier.EventName
            }}
          </b>
        </div>
        <div v-if="$store.state.electionEvent">
          <span class="screenreader">{{
            $t("election-event.screen-reader.from-date")
          }}</span>
          <span
            class="md-caption md-caption-date"
            v-if="
              $store.state.electionEvent.ElectionEvent.EventDate !== null &&
                $store.state.electionEvent.ElectionEvent.EventDate.Start
            "
          >
            {{ $store.state.electionEvent.ElectionEvent.EventDate.Start }}
          </span>
          <span class="screenreader">{{
            $t("election-event.screen-reader.to-date")
          }}</span>
          <span
            class="md-caption md-caption-date"
            v-if="
              $store.state.electionEvent.ElectionEvent.EventDate !== null &&
                $store.state.electionEvent.ElectionEvent.EventDate.End
            "
          >
            -
            {{ $store.state.electionEvent.ElectionEvent.EventDate.End }}
          </span>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-25 md-xsmall-size-50 right-header">
      <div class="md-small-hide">
        <div
          v-if="eventLocale && eventLocale.length > 1"
          class="dropdown-menu"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            v-for="(locale, index) in eventLocale"
            :key="index"
            class="dropdown-item language-button"
            href="#"
            @click.prevent="$i18n.locale = locale"
          >
            {{ locale | capitalize }}
          </a>
        </div>
        <div
          v-if="!eventLocale && locales.length > 1"
          class="dropdown-menu"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            v-for="(locale, index) in locales"
            :key="index"
            class="dropdown-item language-button"
            href="#"
            @click.prevent="$i18n.locale = locale"
          >
            {{ locale | capitalize }}
          </a>
        </div>
      </div>
      <div
        v-if="!eventLocale && locales.length > 1"
        class="dropLang md-layout-item "
      >
        <select v-model="$i18n.locale">
          <option
            v-for="(locale, index) in locales"
            :value="locale"
            :key="index"
          >
            {{ locale | capitalize }}</option
          >
        </select>
      </div>
      <div v-if="eventLocale && eventLocale.length > 1" class="dropLang">
        <select v-model="$i18n.locale">
          <option
            v-for="(locale, index) in eventLocale"
            :value="locale"
            :key="index"
          >
            {{ locale | capitalize }}</option
          >
        </select>
      </div>
      <div>
        <md-button
          @click="logout()"
          class="md-button logout"
          id="logout"
          style="color: #fff"
          ><md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("header.close-button-tooltip") }}</md-tooltip
          >
          <md-icon class="md-size-1x" aria-hidden="true" role="presentation"
            >exit_to_app</md-icon
          >Logout
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";

export default {
  async mounted() {
    this.isMobile = isMobile;
    this.$i18n.locale = this.selectedLang;
    //EnabledLanguage
    // if (this.eventLocale != null) {
    //   this.locales = this.eventLocale;
    //   this.setLocale(this.eventLocale[0]);
    // }
    // //PreferredLanguage
    // if (this.voterLocale != null) this.setLocale(this.voterLocale);
    // console.log("xxx ~ this.eventLocale", this.eventLocale);

    // console.log("xxx ~ this.voterLocale", this.voterLocale);
  },
  data: function() {
    return {
      isMobile: false,
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(","),
      selectedLang: process.env.VUE_APP_I18N_LOCALE,
      isVisible: false,
      focusedIndex: 0
    };
  },
  props: ["showhelp", "userDisabled", "userName", "eventLocale", "voterLocale"],
  methods: {
    logout() {
      this.$emit("logoutRequest");
    },
    hideDropdown() {
      this.isVisible = false;
      this.focusedIndex = 0;
    },
    setLocale() {
      this.$i18n.locale = this.selectedLang;

      // this.selectedLang = locale;
      /* this.$router
        .push({
          params: { locale: locale }
        })
        .catch(() => {}); */
      //this.hideDropdown();
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {}
};
</script>

<style scoped>
select {
  width: auto !important;
  background: var(--pcolor);
  height: 32px !important;
  padding: 0;
  margin: 0 !important;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
  text-transform: uppercase;
  padding-left: 10px;
  margin-top: -4px;
  line-height: 14px !important;
  appearance: menulist !important;
  -webkit-appearance: menulist !important;
}

html.md-theme-default {
  xbackground-color: #f1f1f1 !important;
  xbackground-color: var(--md-theme-default-background-variant, #f1f1f1);
}
.custom {
  padding: 5px;
}

.head {
  max-height: 100px;
}

.md-tabs-navigation {
  height: 50px !important;
}

.md-layout.w-header {
  padding: 20px 0;
  background: var(--pcolor) !important;
  align-items: center;
}

.md-layout-item.md-size-100 {
  min-width: 90% !important;
  max-width: 95% !important;
  margin-left: none;
  flex: 1 1 100%;
  margin: 20px auto !important;
}
.md-layout {
  display: flex;
  flex-wrap: wrap;
  height: auto !important;
}

.customimg[data-v-88f6691c] {
  width: auto;
  height: auto;
  padding: 20px !important;
}
.icon {
  display: block;
  margin: auto;
}
.customimg {
  width: auto;
  height: auto;
}

.logo-div {
  display: flex;
  justify-content: left;
}
.customimg.logo {
  width: 100px;
  margin-left: 40px;
}

.tooltip {
  z-index: 10;
}

/* .logout {
  margin: 8px 0 0 0;
} */

.logout {
  background-color: var(--pcolor);
}

.logout .md-icon.md-theme-default.md-icon-font {
  color: #fff !important;
  margin-right: 5px;
  background-color: var(--pcolor);
}

/* .dropdown-menu {
  width: 60%;
  float: right;
} */

.language-button {
  border: solid 1px #fff;
  padding: 5px;
  margin: 0 2px;
  font-size: 14px;
  text-align: center;
  color: #fff !important;
  border-radius: 5px;
  background-color: var(--pcolor);
}

.logo-evt {
  max-height: 50px;
}

.center-header {
  display: flex;
  align-items: center;
  column-gap: 10px;
  color: #fff;
  justify-content: center;
}

.center-header .md-caption {
  color: #fff;
}

.right-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.right-header a:not(.md-button) {
  width: 34px;
  display: inline-block;
}

.md-button {
  border-radius: var(--brb);
}

.md-button,
.md-button-clean {
  overflow: auto !important;
}

.md-theme-default .md-caption {
  color: #fff !important;
}

.event-name,
.md-caption-date {
  background-color: var(--pcolor);
}

@media screen and (min-width: 961px) {
  /* .customimg.logo {
    width: auto;
  } */
  .dropLang {
    display: none;
  }
}
</style>
